// extracted by mini-css-extract-plugin
export default {"main":"Home_main__nW-1q","select":"Home_select__+CVXA","form":"Home_form__434QM","card":"Home_card__cnaP8","cardtitle":"Home_cardtitle__fs3SF"};